import { useWizard } from "react-use-wizard";
import RangeByRegionByFacilityTypeStep from "../../../../../shared/wizard/steps/rangeByRegionByFacilityTypeStep";
import tradeInSteps from "./tradeInSteps";

interface ITradeInStep_9 {
  typeIds: number[] | null;
  selectedPolygonIds: number[] | null;
}

const TradeInStep_9 = ({ typeIds, selectedPolygonIds }: ITradeInStep_9) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(tradeInSteps.step_8.step);
  };

  const handleNextStep = () => {
    goToStep(tradeInSteps.step_10.step);
  };

  return (
    <div>
      <RangeByRegionByFacilityTypeStep
        counterPage={{
          current: tradeInSteps.step_9.page,
          max: tradeInSteps.step_9.maxPage,
        }}
        typeIds={typeIds ?? []}
        selectedPolygonIds={selectedPolygonIds ?? []}
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
      />
    </div>
  );
};
export default TradeInStep_9;
